/**
 * Doble verificación Odoo: consulta stock real antes de ir al checkout.
 * Fail-open: si Odoo no responde, deja continuar el checkout.
 */
(function () {
  'use strict';

  const cfg = window.MYA_ODOO_STOCK_CHECK || {};
  if (!cfg.enabled) return;

  const STOCK_CHECK_URL =
    cfg.url || 'https://myac.odoo.com/shopify-odoo/v1/stock-check';
  const STOCK_KEY = cfg.key || '';
  const MSG_DEFAULT =
    cfg.message ||
    'Algunos productos ya no tienen stock suficiente en bodega. Revisa tu carrito.';

  let busy = false;

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  async function verifyCartWithOdoo() {
    const cart = await fetchCart();
    const items = (cart.items || [])
      .filter(function (i) {
        return i.sku;
      })
      .map(function (i) {
        return { sku: String(i.sku), qty: Number(i.quantity) || 0 };
      })
      .filter(function (i) {
        return i.sku && i.qty > 0;
      });

    if (!items.length) {
      return { available: true, unavailable: [] };
    }

    const headers = { 'Content-Type': 'application/json' };
    if (STOCK_KEY) {
      headers['X-Shopify-Stock-Key'] = STOCK_KEY;
    }

    const res = await fetch(STOCK_CHECK_URL, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ items: items }),
    });

    if (!res.ok) {
      throw new Error('stock-check ' + res.status);
    }
    return res.json();
  }

  function formatUnavailable(list) {
    if (!list || !list.length) return MSG_DEFAULT;
    return list
      .map(function (u) {
        if (u.reason === 'insufficient_stock') {
          return (
            (u.sku || 'SKU') +
            ': solo quedan ' +
            (u.available_qty != null ? u.available_qty : 0)
          );
        }
        if (u.reason === 'not_shopify_sync' || u.reason === 'no_image') {
          return (u.sku || 'SKU') + ': no disponible para venta online';
        }
        if (u.reason === 'product_not_found') {
          return (u.sku || 'SKU') + ': no encontrado en bodega';
        }
        return (u.sku || 'SKU') + ': no disponible';
      })
      .join('\n');
  }

  function findCheckoutForm(btn) {
    if (btn.form) return btn.form;
    const byId = document.getElementById('cart-form');
    if (byId) return byId;
    return btn.closest('form');
  }

  function proceedToCheckout(btn) {
    const form = findCheckoutForm(btn);
    if (form) {
      // Asegura que el submit sea "checkout"
      let input = form.querySelector('input[name="checkout"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        input.value = '1';
        form.appendChild(input);
      }
      form.submit();
      return;
    }
    window.location.href = '/checkout';
  }

  async function onCheckoutIntent(e, btn) {
    if (busy) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    busy = true;
    const prevDisabled = btn.disabled;
    btn.disabled = true;

    try {
      const result = await verifyCartWithOdoo();
      if (result && result.available) {
        proceedToCheckout(btn);
        return;
      }
      alert(formatUnavailable(result && result.unavailable));
    } catch (err) {
      console.warn('[MYA Odoo stock-check]', err);
      // fail-open
      proceedToCheckout(btn);
    } finally {
      busy = false;
      btn.disabled = prevDisabled;
    }
  }

  function isCheckoutButton(el) {
    if (!el || el.nodeType !== 1) return null;
    const btn = el.closest(
      '#checkout, [name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"]'
    );
    if (!btn) return null;
    // Solo interceptar botones de checkout, no otros submits del carrito
    if (btn.id === 'checkout' || btn.getAttribute('name') === 'checkout') {
      return btn;
    }
    if (btn.classList && btn.classList.contains('cart__checkout-button')) {
      return btn;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = isCheckoutButton(e.target);
      if (!btn) return;
      onCheckoutIntent(e, btn);
    },
    true
  );
})();
